module.exports = __webpack_public_path__ + "static/media/bus_icon_green.07df53a3.svg";